import constants from './constants';
import api from './api';
import {createAsyncAction} from '../../utils/thunk_utils';

export const toggleUpdateMode = (flag) => ({
  type: constants.TOGGLE_UPDATE_MODE,
  data: flag,
})

export const createSchedule = (data) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.CREATE_SCHEDULE,
    api.createSchedule
  )(data))
};

export const updateSchedule = (data) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.UPDATE_SCHEDULE,
    api.updateSchedule
  )(data))
};

export const getSchedule = (id) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.GET_SCHEDULE,
    api.getSchedule
  )(id))
};

export const cancelSchedule = (data) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.CANCEL_SCHEDULE,
    api.cancelSchedule
  )(data))
};

export const confirmSchedule = (data) => (dispatch) => {
  dispatch(createAsyncAction(
    constants.CONFIRM_SCHEDULE,
    api.confirmSchedule
  )(data))
};

export const onValueChange = (data) => ({
  type: constants.ON_VALUE_CHANGE,
  data,
})

